<template>
    <div id="home" class="flex w100 h100">
        <div class="w100 home_left">
            <div class="greet_msg mgbt20">
                <img class="home_avatar" :src="(avatar != '')? avatar : ''" alt="Chưa có ảnh">
                <h3>Chào {{userdata.fullname}}!</h3>                
                <span>Chúc bạn một ngày làm việc hiệu quả.</span>
            </div>

        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import {callApi} from '@/helper/function'
import axios from 'axios'

export default {
    name : 'chat',
    data () {
        return {
            show_right: true,
            userdata:{},
            avatar: '',
        }
    },
    created() {
        this.userdata = Object.assign({}, this.getUser)
        if(this.userdata.avatar != ''){
            this.avatar = process.env.VUE_APP_WEBURL + '/upload/avatar/' + this.userdata.avatar + '?v='+ parseInt(Math.random()*1000)
        }

    },
    computed: {
        ...mapGetters(['getUser'])
    },
    methods: {
        
    },
}
</script>
<style scoped>
.exploder{
    position: absolute;
    right: 0px;
    top: 16px;
}
#home{
    overflow-y: auto;
}
.greet_msg{
    position: relative;
    padding-left: 80px;
    font-weight: 500;
    padding-top: 5px;
    padding-right: 200px;
}
.home_avatar{
    width: 60px;
    position: absolute;
    left: 0;
    top: 0;
    height: 60px;
}
.home_left{
    padding: 50px;
    overflow: auto;
}
.home_right{
    background-color: #f4f9ff;
    border-left: 1px solid #ddd;
    overflow: auto;
}
.hr_title{
    border-bottom: 1px solid #ddd;
    padding: 0px 50px 0px 10px;
    position: relative;
    font-size: 16px;
    height: 40px;
    line-height: 40px;
}
.close_exploder{
    position: absolute;
    right: 0;
    width: 40px;
    height: 40px;
    top: 0;
    line-height: 40px;
    text-align: center;
    font-size: 20px;
    cursor: pointer;
}
.row_suggest{
    margin: 10px;
    border: 1px solid #ddd;
    border-radius: 5px;
    padding: 15px;
    background-color: #fff;
}
.row_notice{
    background-color: #ffffba;
}
.suggest_title{
    font-size: 14px;
}
.suggest_item{
    display: block;
    position: relative;
    padding-left: 50px;
    height: 40px;
    line-height: 40px;
}
.suggest_icon{
    position: absolute;
    left: 0;
    height: 40px;
    width: 40px;
    text-align: center;
    line-height: 40px;
    color: #999;
}
.suggest_item a{
    display: block;
    white-space: nowrap;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #222;
    height: 100%;
    line-height: 40px;
}
</style>
